import { COLUMN_CODES, CONSTANTS, MESSAGES } from "../../constants/Constant";
import { PAGE_ROUTES } from "../../managers/RouteManager";

export interface ReportConfig {
    id: string;
    name: string;
    icon?: string;
    hidden?: boolean;
    url: string;
    env?: string[];
    year?:boolean;
    quarter?:boolean;
    employees?:boolean;
    isDefaultRouteConfigured?: boolean;
    description?:string;
    isToolTip?:boolean;
    tooltipDescription?:string;
    isRouteToCommonReports?: boolean,
    module?: string
}

export interface ReportCard {
    title: string;
    icon?: string;
    hidden?: boolean;
    reports: ReportConfig[];
}
export interface ReportColumn {
    column1: ReportCard[];
    column2?: ReportCard[];
    column3?: ReportCard[];
    automationReport?: ReportCard[];
    statutoryReports?: ReportCard[];
}
export const USReportConfig: ReportColumn = {
    column1: [
        {
            title: 'Payroll Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'monthlyPayrollReport',
                    name: 'Payroll Summary Report',
                    hidden: true,
                    url: PAGE_ROUTES.REPORT.US.PAYROLL_SUMMARY
                },
                {
                    id: 'payrollSummaryReport',
                    name: 'Payroll Summary Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.SG.PAYROLL_SUMMARY
                },
                {
                    id: 'payrollLiabilityReport',
                    name: 'Payroll Liability Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.IN.PAYROLL_LIABILITY
                }
            ]
        }
    ],
    column2: [
        {
            title: 'Employee Withholding Forms',
            icon: 'Forms.svg',
            reports: [
                {
                    id: 'W4FormForEmployees',
                    name: 'W-4 Form for Employees',
                    url: PAGE_ROUTES.REPORT.US.W4_FORM
                },
                {
                    id: 'W2Form',
                    name: 'W-2 Form',
                    url: PAGE_ROUTES.REPORT.US.W2_FORM,
                    isToolTip: true,
                    tooltipDescription:MESSAGES.W2_TOOLTIP
                },
                {
                    id: 'W3Form',
                    name: 'W-3 Form',
                    url: PAGE_ROUTES.REPORT.US.W3_FORM
                },
                {
                    id: 'W9FormForContractors',
                    name: 'W-9 Form for Contractors',
                    url: PAGE_ROUTES.REPORT.US.W9_FORM
                },
                {
                    id: '1099Misc',
                    name: '1099 (Misc)',
                    url: PAGE_ROUTES.REPORT.US.MISC1099,
                    isToolTip: true,
                    tooltipDescription:MESSAGES.MISC_TOOLTIP
                },
                {
                    id: '1099NEC',
                    name: '1099 (NEC)',
                    url: PAGE_ROUTES.REPORT.US.NEC1099
                }
            ]
        }
    ],
    column3: [
        {
            title: 'Federal Forms',
            icon: 'Forms.svg',
            reports: [
                {
                    id: 'FORM940',
                    name: 'Form 940',
                    url: PAGE_ROUTES.REPORT.US.FORM,
                    year: true,
                    quarter: false,
                    employees: false,
                    isDefaultRouteConfigured: true,
                    description: "Form 940"
                },
                {
                    id: 'form941',
                    name: 'Form 941',
                    url: PAGE_ROUTES.REPORT.US.FORM941
                },
                {
                    id: 'form944',
                    name: 'Form 944',
                    url: PAGE_ROUTES.REPORT.US.FORM944
                },
                {
                    id: 'formI9',
                    name: 'Form I-9',
                    url: PAGE_ROUTES.REPORT.US.I9
                }
            ]
        }
    ],
    automationReport: [
        {
            title: 'Automation Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'workflowReport',
                    name: 'Workflow Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.WORKFLOW
                },
                {
                    id: 'commissionReport',
                    name: 'Commission Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.COMMISSION
                }
            ]
        }
    ]
};
export const USEmployeeReportConfig: ReportColumn = {
    column1: [
        {
            title: 'Employee Withholding Forms',
            icon: 'Forms.svg',
            reports: [
                {
                    id: 'W4FormForEmployees',
                    name: 'W-4 Form',
                    url: PAGE_ROUTES.REPORT.US.W4_FORM
                },
                {
                    id: 'W2Form',
                    name: 'W2 Form',
                    url: PAGE_ROUTES.REPORT.US.W2_FORM
                }
            ]
        }
    ],
    column2: [{
        title: 'Federal Forms',
        icon: 'Forms.svg',
        reports: [ {
            id: 'formI9',
            name: 'Form I-9',
            url: PAGE_ROUTES.REPORT.US.I9
        }]
    }]
};

export const INReportConfig: ReportColumn = {
    column1: [
        {
            title: 'Payroll Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'payrollSummaryReport',
                    name: 'Payroll Summary Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.SG.PAYROLL_SUMMARY
                },
                {
                    id: 'payrollLiabilityReport',
                    name: 'Payroll Liability Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.IN.PAYROLL_LIABILITY
                },
                {
                    id: 'form16',
                    name: 'Form 16',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.IN.FORM16
                }
            ]
        }
    ],
    automationReport: [
        {
            title: 'Automation Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'workflowReport',
                    name: 'Workflow Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.WORKFLOW
                },
                {
                    id: 'commissionReport',
                    name: 'Commission Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.COMMISSION
                }
            ]
        }
    ],
    column2: [
        {
            title: 'Statutory Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'professionalTaxReport',
                    name: 'Professional Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.STATUTORY_REPORTS.PROFESSIONAL_TAX +"/PT"
                },
                {
                    id: 'esiTaxReport',
                    name: 'ESI Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.STATUTORY_REPORTS.PROFESSIONAL_TAX + "/ESI"
                },
                {
                    id: 'epfTaxReport',
                    name: 'EPF Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.STATUTORY_REPORTS.PROFESSIONAL_TAX + "/EPF"
                },
                {
                    id: 'wageRegisterReport',
                    name: 'Wage Register Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.STATUTORY_REPORTS.WAGE_REGISTER
                }
            ]
        },
        
    ],
};
export const DefaultReportConfig: ReportColumn = {
    column1: [
        {
            title: 'Payroll Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'payrollSummaryReport',
                    name: 'Payroll Summary Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.SG.PAYROLL_SUMMARY
                }
            ]
        }
    ]
};

export const SGReportConfig: ReportColumn = {
    column1: [
        {
            title: 'Payroll Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'payrollSummaryReport',
                    name: 'Payroll Summary Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.SG.PAYROLL_SUMMARY
                },
                {
                    id: 'payrollLiabilityReport',
                    name: 'Payroll Liability Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.IN.PAYROLL_LIABILITY
                }
            ]
        }
    ],
    column2: [
        {
            title: 'CPF',
            icon: 'CPF.svg',
            reports: [
                {
                    id: 'CPFeSubmission',
                    name: 'CPF E-Submission',
                    url: PAGE_ROUTES.REPORT.SG.CPF_SUBMISSION,
                    isRouteToCommonReports:true,
                    module: "CPF_E_SUBMISSION"
                }
            ]
        }
    ],
    column3: [
        {
            title: 'IRAS',
            icon: 'IRAS.svg',
            reports: [
                {
                    id: 'IRASSummaryReport',
                    name: 'IRAS Summary Report',
                    url: PAGE_ROUTES.REPORT.SG.IRAS_SUMMARY_REPORT
                },
                {
                    id: 'IR8AFormDownload',
                    name: 'IR8A Form',
                    url: PAGE_ROUTES.REPORT.SG.IR8A_REPORT,
                    isRouteToCommonReports:true,
                    module: "IR8A_FORM"
                },
                {
                    id: 'IR8SFormDownload',
                    name: 'IR8S Form',
                    url: PAGE_ROUTES.REPORT.SG.IR8S_REPORT,
                    isRouteToCommonReports:true,
                    module: "IR8S_FORM"
                },
                {
                    id: 'Appendix8A',
                    name: 'Appendix 8A',
                    url: PAGE_ROUTES.REPORT.SG.APPENDIX_8A,
                    isRouteToCommonReports:true,
                    module: "APPENDIX_8A"
                },
                {
                    id: 'Appendix8B',
                    name: 'Appendix 8B',
                    url: PAGE_ROUTES.REPORT.SG.APPENDIX_8B,
                    isRouteToCommonReports:true,
                    module: "APPENDIX_8B"
                },
                {
                    id: 'IRASeSubmission',
                    name: 'IRAS E-Submission',
                    url: PAGE_ROUTES.REPORT.SG.IRAS_E_SUBMISSION,
                    isRouteToCommonReports:true,
                    module: "IRAS_E_SUBMISSION"
                },
                {
                    id: 'AISSubmission',
                    name: 'IRAS AIS Submission',
                    url: PAGE_ROUTES.REPORT.SG.IRAS_AIS_SUBMISSION,
                }
            ]
        }
    ],
    automationReport: [
        {
            title: 'Automation Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'workflowReport',
                    name: 'Workflow Report',
                     hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.WORKFLOW
                },
                {
                    id: 'commissionReport',
                    name: 'Commission Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.COMMISSION
                }
            ]
        }
    ]
};

export const MYReportConfig: ReportColumn = {
    column1: [
        {
            title: 'Payroll Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'payrollSummaryReport',
                    name: 'Payroll Summary Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.SG.PAYROLL_SUMMARY
                },
                {
                    id: 'payrollLiabilityReport',
                    name: 'Payroll Liability Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.IN.PAYROLL_LIABILITY
                }
            ]
        }
    ],
    column2: [
        {
            title: 'Monthly Forms',
            icon: 'CPF.svg',
            reports: [
                {
                    id: 'CP39',
                    name: 'CP39',
                    url: PAGE_ROUTES.REPORT.MY.CP39
                },
                {
                    id: 'SOCSOBorang8A',
                    name: 'SOCSO Borang 8A',
                    url: PAGE_ROUTES.REPORT.MY.SOCSOBorang8A
                },
                {
                    id: 'KWSPBorangA',
                    name: 'KWSP Borang A',
                    url: PAGE_ROUTES.REPORT.MY.KWSPBorangA
                },
                {
                    id: 'SIP',
                    name: 'SIP',
                    url: PAGE_ROUTES.REPORT.MY.SIP
                }
            ]
        }
    ],
    column3: [
        {
            title: 'Yearly Forms',
            icon: 'IRAS.svg',
            reports: [
                {
                    id: 'EAForm',
                    name: 'EA Form',
                    url: PAGE_ROUTES.REPORT.MY.EAForm
                },
                {
                    id: 'CP8D',
                    name: 'CP8D',
                    url: PAGE_ROUTES.REPORT.MY.CP8D
                }
            ]
        }
    ],
    automationReport: [
        {
            title: 'Automation Reports',
            icon: 'Reports.svg',
            reports: [
                {
                    id: 'workflowReport',
                    name: 'Workflow Report',
                     hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.WORKFLOW
                },
                {
                    id: 'commissionReport',
                    name: 'Commission Report',
                    hidden: false,
                    url: PAGE_ROUTES.REPORT.AUTOMATION.COMMISSION
                }
            ]
        }
    ]
};


export const FEDERAL_FREQUENCY = [
    {
        id: 0,
        value: '1st Quarter (Jan,Feb,Mar)'
    },
    {
        id: 3,
        value: '2nd Quarter (Apr,May,Jun)'
    },
    {
        id: 6,
        value: '3rd Quarter (July,Aug,Sep)'
    },
    {
        id: 9,
        value: '4th Quarter (Oct,Nov,Dec)'
    }
];
export const FEDRAL_INFO = "Deskera People do not provide e-submission or filing services for any Federal or State forms. We have prefilled all information from the system in these forms. Please review them carefully and ensure that you are filing these well within your submission timelines.";

export const STATE_FORM_ROUTES = {
    [COLUMN_CODES.WHT_434]: {URL: PAGE_ROUTES.REPORT.US.FORM, FORM: "WHT434"},
    [COLUMN_CODES.WHT_436] : {URL: PAGE_ROUTES.REPORT.US.FORM, FORM: "WHT436"},
    [COLUMN_CODES.C101_C_147] : {URL: PAGE_ROUTES.REPORT.US.FORM, FORM: "FORMC147"},
    [CONSTANTS.REPORT_NO_ROUTE] : {URL: PAGE_ROUTES.REPORT.US.FORM, FORM: "FORM"},
    [COLUMN_CODES.FORM_940]: {URL: PAGE_ROUTES.REPORT.US.FORM, FORM: "FORM940"}
}
export const STATUTORY_CONSTANT = {
    PT: {
        type:"PT",
        title: "PRO_TAX_REPORT",
        cardTitle: "GENERATE_PRO_TAX_REPORT",
        report: "ptReport",
        downloadFileType: ".csv"
    },
    EPF: {
        type:"EPF",
        title: "EPF_TAX_REPORT",
        cardTitle: "GENERATE_EPF_TAX_REPORT",
        report: "epfReport",
        downloadFileType: ".txt"
    },
    ESI: {
        type:"ESI",
        title: "ESI_TAX_REPORT",
        cardTitle: "GENERATE_ESI_TAX_REPORT",
        report: "esiReport",
        downloadFileType: ".csv"
    }
}